<a class="db-tab-head" [ngClass]="{'db-tab-head_active': !tabId || tabId === activeTabId, 'db-hide-tab': hideTab}" (click)="onClick()">
  <ng-content></ng-content>
</a>
